import { Component } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `<span class="created-by">{{year}}</span>`,
})
export class FooterComponent {

  public year: number;

  constructor() {
    this.year = moment().year();
  }
}
